import React from 'react';
import clientService from '../../services/client';
import {Field, change, reduxForm} from 'redux-form';
import LoadingScreen from '../LoadingScreen';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

class AddMultipleEmployeeForm extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isChecking:false,
            canAddEmployees: false,
            masterListUrl: "",
            errorMessage:"",
            filename: ""
        }
    }

    componentDidMount(){

        const {dispatch, accessToken, refCode, clientId} = this.props;

        dispatch(change("addMultipleEmployeeForm", "access_token",accessToken));
        dispatch(change("addMultipleEmployeeForm", "ref_code",refCode));
        dispatch(change("addMultipleEmployeeForm", "client_id",clientId));

        this.setState({
            isChecking: true
        });

        clientService.getInvoicePlanMasterList(refCode, accessToken, clientId)
            .then((data)=>{
                this.setState({
                    isChecking: false,
                    canAddEmployees: true,
                    masterListUrl: data.url
                })
            }, (err)=>{
                this.setState({
                    isChecking: false,
                    canAddEmployees: false,
                    masterListUrl: "",
                    errorMessage: err?.response?.data?.message
                })
            })

    }

    handleChange = (event) => {
        if(event.target.files.length > 0) {
            this.setState({
                filename: event.target.files[0]?.name
            })
        }
    }

    render(){
        const { handleSubmit, pristine, submitting, t, isFrozen } = this.props;

        const { isChecking, canAddEmployees, masterListUrl, errorMessage } = this.state;

        if(isChecking) return <LoadingScreen/>;

        if(!isChecking && !canAddEmployees)
            return (
                <div style={{display:"flex", justifyContent:"center", flexDirection:"column", height:"400px"}}>
                    <div style={{ padding: "2rem",background: "red", color: "white",fontSize: "1.3em"}}>
                        {errorMessage}
                    </div>
                </div>
            );

        if(!isChecking && canAddEmployees)
        return (
            <form onSubmit={handleSubmit}>
                <h3 style={{textAlign: i18next.dir() === 'rtl' ? 'right' : 'left' }}>{t("invoices.addMultipleEmployeeFormTitle")}</h3>
                <p>{t("invoices.addMultipleEmployeeFormSubTitle")}</p>
                <p>&nbsp;</p>
                <div className="multiple-upload-section">
                <a
                    href={masterListUrl}
                    className="form-button content"
                    style={{display:"block", textDecoration:"none", textAlign:"center"}}>
                    {t("invoices.csvDownloadLinkTitle")}
                </a>
                <p>&nbsp;</p>
                <p>{t("invoices.uploadInstruction")}</p>
                    <div className="file-upload-wrapper">
                    <label
                        className="file-upload-icon-button"
                        htmlFor="file"
                        style={isFrozen ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
                    >
                        <FileUploadOutlinedIcon />
                        <Field component={CustomFileInput} onChange={this.handleChange} name="file" type="hidden" style={{display:"none"}} disabled={isFrozen}/>
                    </label>
                    <p>{this.state.filename}</p>
                    <p>{t("invoices.chooseFileForUpload")}</p>
                    <p>&nbsp;</p>
                    <span>CSV, XLS</span>
                    </div>
                <Field component="input" name="access_token" type="hidden" style={{display:"none"}}/>
                <Field component="input" name="client_id" type="hidden" style={{display:"none"}}/>
                <Field component="input" name="ref_code" type="hidden" style={{display:"none"}}/>
                <p>&nbsp;</p>
                <div className="upload-button-wrapper">
                <button
                    className="form-button upload"
                    // style={{backgroundColor:"#2eaf31"}}
                    type="submit"
                    disabled={pristine || submitting || isFrozen}>
                    {t("invoices.fileUploadButtonText")}
                </button>
                </div>
                </div>
            </form>
        );
    }
}

AddMultipleEmployeeForm = reduxForm({
    form:"addMultipleEmployeeForm"
})(AddMultipleEmployeeForm);

const CustomFileInput = (field, hidden) => {
    delete field.input.value; // <-- just delete the value property
    return <input type="file" id="file" hidden {...field.input} disabled={field.disabled}/>;
};

const AddMultipleEmployeeFormWithTranslation = withTranslation()(AddMultipleEmployeeForm);
export default AddMultipleEmployeeFormWithTranslation;